module.exports = __webpack_public_path__ + "static/media/logo_apoteka.626f8a0a.svg";